var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _rect, _path49, _path50, _path51, _path52, _rect2, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _rect3, _path61, _path62, _defs, _path63, _defs2, _polygon, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _defs3, _path84, _defs4, _path85, _defs5, _path86, _path87, _path88, _defs6, _path89, _defs7, _path90, _defs8, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _defs9, _path111, _defs10, _path112, _defs11, _path113, _path114, _path115, _defs12, _path116, _defs13, _path117, _defs14, _path118, _path119, _path120;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1224 792",
    style: {
      enableBackground: "new 0 0 1224 792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CBE4F8;}\n\t.st1{fill:#3678BC;}\n\t.st2{fill:#72AEE0;}\n\t.st3{fill:#71BEEB;}\n\t.st4{fill:#ABD2F0;}\n\t.st5{fill:#91C2EA;}\n\t.st6{fill:#FDC50A;}\n\t.st7{fill:#3C407B;}\n\t.st8{fill:#222E5A;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:#E7E0E7;}\n\t.st11{fill:#3E9AD5;}\n\t.st12{opacity:0.2;}\n\t.st13{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n\t.st14{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\n\t.st15{opacity:0.3;}\n\t.st16{clip-path:url(#SVGID_6_);fill:#FFFFFF;}\n\t.st17{clip-path:url(#SVGID_8_);fill:#FFFFFF;}\n\t.st18{clip-path:url(#SVGID_10_);fill:#FFFFFF;}\n\t.st19{clip-path:url(#SVGID_12_);fill:#FFFFFF;}\n\t.st20{clip-path:url(#SVGID_14_);fill:#FFFFFF;}\n\t.st21{clip-path:url(#SVGID_16_);fill:#FFFFFF;}\n\t.st22{clip-path:url(#SVGID_18_);fill:#FFFFFF;}\n\t.st23{clip-path:url(#SVGID_20_);fill:#FFFFFF;}\n\t.st24{clip-path:url(#SVGID_22_);fill:#FFFFFF;}\n\t.st25{clip-path:url(#SVGID_24_);fill:#FFFFFF;}\n\t.st26{clip-path:url(#SVGID_26_);fill:#FFFFFF;}\n\t.st27{clip-path:url(#SVGID_28_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M705.7,210.3c0,1.7-0.7,3.3-1.8,4.4c-1.1,1.1-2.7,1.8-4.4,1.8h-134c-3.4,0-6.3-2.8-6.3-6.3 c0-1.7,0.7-3.3,1.8-4.4c1.1-1.1,2.7-1.8,4.4-1.8h6.3c2.5-5.8,8.3-9.9,15-9.9c4.5,0,8.6,1.8,11.6,4.8c3.9-6.7,11.2-11.2,19.6-11.2 c2.3,0,4.5,0.3,6.6,1c4.4-8.2,13-13.8,22.9-13.8c11.9,0,22,8.1,25,19c2.2-1.1,4.7-1.7,7.3-1.7c7.4,0,13.7,5,15.7,11.8h4 C702.9,204,705.7,206.9,705.7,210.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519,186.6c0,1.3-0.5,2.4-1.4,3.3c-0.8,0.8-2,1.4-3.2,1.4h-98.5c-2.5,0-4.6-2.1-4.6-4.6c0-1.3,0.5-2.4,1.4-3.3 c0.8-0.8,2-1.4,3.2-1.4h4.7c1.8-4.3,6.1-7.3,11-7.3c3.3,0,6.3,1.4,8.5,3.5c2.9-4.9,8.3-8.2,14.4-8.2c1.7,0,3.3,0.3,4.8,0.7 c3.2-6,9.5-10.1,16.8-10.1c8.8,0,16.2,5.9,18.4,14c1.6-0.8,3.4-1.3,5.4-1.3c5.5,0,10.1,3.7,11.5,8.7h3C516.9,182,519,184,519,186.6 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M852.6,181.1c0,1.3-0.5,2.4-1.4,3.3c-0.8,0.8-2,1.4-3.2,1.4h-98.5c-2.5,0-4.6-2.1-4.6-4.6 c0-1.3,0.5-2.4,1.4-3.3c0.8-0.8,2-1.4,3.2-1.4h4.7c1.8-4.3,6.1-7.3,11-7.3c3.3,0,6.3,1.4,8.5,3.5c2.9-4.9,8.3-8.2,14.4-8.2 c1.7,0,3.3,0.3,4.8,0.7c3.2-6,9.5-10.1,16.8-10.1c8.8,0,16.2,5.9,18.4,14c1.6-0.8,3.4-1.3,5.4-1.3c5.5,0,10.1,3.7,11.5,8.7h3 C850.6,176.5,852.6,178.5,852.6,181.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M879.1,616.5c0,10.9-119.5,19.8-266.9,19.8s-266.9-8.9-266.9-19.8c0-10.9,119.5-19.8,266.9-19.8 S879.1,605.6,879.1,616.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M790.6,348.7c0,4-3.2,7.2-7.2,7.2c-4,0-7.2-3.2-7.2-7.2c0-4,3.2-7.2,7.2-7.2 C787.3,341.5,790.6,344.7,790.6,348.7 M788.3,348.7c0-2.7-2.2-4.9-4.9-4.9c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9 C786.1,353.6,788.3,351.4,788.3,348.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M822.3,327.7c0,4-3.2,7.2-7.2,7.2c-4,0-7.2-3.2-7.2-7.2c0-4,3.2-7.2,7.2-7.2 C819.1,320.5,822.3,323.7,822.3,327.7 M820,327.7c0-2.7-2.2-4.9-4.9-4.9c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9 C817.8,332.6,820,330.4,820,327.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M818.3,300.5c-0.6,0-1.1,0.5-1.1,1.1v5c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-5 C819.4,301,818.9,300.5,818.3,300.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M818.3,291.8c-0.6,0-1.1,0.5-1.1,1.1v5c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-5 C819.4,292.3,818.9,291.8,818.3,291.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M825.3,298.6h-4.5c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1h4.5c0.6,0,1.1-0.5,1.1-1.1S825.9,298.6,825.3,298.6 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M815.8,298.6h-4.5c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1h4.5c0.6,0,1.1-0.5,1.1-1.1S816.4,298.6,815.8,298.6 "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M779.3,319.3c-0.6,0-1.1,0.5-1.1,1.1v5c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-5 C780.4,319.8,779.9,319.3,779.3,319.3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M779.3,310.6c-0.6,0-1.1,0.5-1.1,1.1v5c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-5 C780.4,311.1,779.9,310.6,779.3,310.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M786.3,317.4h-4.5c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h4.5c0.6,0,1.1-0.5,1.1-1.1 C787.4,317.9,786.9,317.4,786.3,317.4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M776.7,317.4h-4.5c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h4.5c0.6,0,1.1-0.5,1.1-1.1 C777.9,317.9,777.4,317.4,776.7,317.4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M466.4,223.8c-4,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2c4,0,7.2,3.2,7.2,7.2S470.4,223.8,466.4,223.8 M466.4,221.5 c2.7,0,4.9-2.2,4.9-4.9c0-2.7-2.2-4.9-4.9-4.9c-2.7,0-4.9,2.2-4.9,4.9C461.5,219.3,463.7,221.5,466.4,221.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M487,247.6c-4,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2c4,0,7.2,3.2,7.2,7.2S491,247.6,487,247.6 M487,245.3 c2.7,0,4.9-2.2,4.9-4.9c0-2.7-2.2-4.9-4.9-4.9c-2.7,0-4.9,2.2-4.9,4.9C482,243.1,484.3,245.3,487,245.3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M505.3,211.3c0-0.6-0.5-1.1-1.1-1.1h-5c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h5 C504.8,212.5,505.3,212,505.3,211.3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M514,211.3c0-0.6-0.5-1.1-1.1-1.1h-5c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h5 C513.5,212.5,514,212,514,211.3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M507.2,218.3v-4.5c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v4.5c0,0.6,0.5,1.1,1.1,1.1 C506.7,219.5,507.2,219,507.2,218.3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M507.2,208.8v-4.5c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v4.5c0,0.6,0.5,1.1,1.1,1.1 C506.7,210,507.2,209.4,507.2,208.8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M448.7,253.4c0-0.6-0.5-1.1-1.1-1.1h-5c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h5 C448.2,254.6,448.7,254.1,448.7,253.4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M457.5,253.4c0-0.6-0.5-1.1-1.1-1.1h-5c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h5 C457,254.6,457.5,254.1,457.5,253.4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M450.6,260.4v-4.5c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v4.5c0,0.6,0.5,1.1,1.1,1.1 C450.1,261.6,450.6,261,450.6,260.4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M450.6,250.9v-4.5c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v4.5c0,0.6,0.5,1.1,1.1,1.1 C450.1,252,450.6,251.5,450.6,250.9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M550.2,555.2l-2.9,1.7l-1.5,0.9l-4.3,2.5c0,0-81.5-41.4-70.8-78.7c3.3-11.5,20-14.4,36.6,18.1 C522.7,529.9,550.2,555.2,550.2,555.2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M547.3,556.9l-1.5,0.9c-17.1-11.7-31.6-26.8-41-37.8c-11.2-13.1-18-23.5-18.1-23.6c-0.2-0.4-0.1-0.9,0.2-1.1 c0.4-0.2,0.9-0.1,1.1,0.2c0.1,0.1,6.8,10.4,18,23.4C515.5,530,530.1,545.2,547.3,556.9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.1,565l-2.7,3.7l-1.5,2l-4.1,5.6c0,0-126-8.1-132.8-61.2c-2.1-16.4,17.5-29.2,56.4,3 C516.4,547.9,565.1,565,565.1,565"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M562.4,568.7l-1.5,2c-28.1-5.5-54.7-16.8-72.7-25.6c-21.4-10.5-35.7-20-35.8-20.1c-0.5-0.3-0.6-1-0.3-1.5 c0.3-0.5,1-0.6,1.5-0.3c0.1,0.1,14.3,9.5,35.6,20C507.3,552,534.1,563.3,562.4,568.7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M719.2,503.4c15.9-20.5,31.4-42.9,39.8-58.9c11.1-20.9,15.5-37.7,13.2-49.8c-0.2-0.8-0.9-1.3-1.7-1.2 c-0.8,0.2-1.3,0.9-1.2,1.7c4.1,21.2-14.4,58.5-53.5,107.7L719.2,503.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M767.4,425.1c0,0,10.3,6.9,21.8-11.7C789.2,413.4,770.4,407.3,767.4,425.1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M762,435c0,0,7.5-9.9-10.4-22.4C751.6,412.6,744.4,431,762,435"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M771.2,404.3c0,0,10.4-6.8-2.4-24.6C768.9,379.7,756,394.7,771.2,404.3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M751.7,455.2c0,0,7.4,10,24.4-3.6C776.1,451.6,760.5,439.5,751.7,455.2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M744.7,464.4c0,0,9.1-8.5-6.4-23.9C738.3,440.6,728,457.5,744.7,464.4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M736.3,478c0,0,7.2,10.1,24.5-3.1C760.8,474.9,745.4,462.5,736.3,478"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.2,375.7c-21.1-15.2-42.2-32.2-54.9-45.2c-16.5-16.9-25.5-31.8-26.8-44.1c-0.1-0.8,0.5-1.5,1.3-1.6 c0.8-0.1,1.5,0.5,1.6,1.3c2.1,21.5,30.4,52,81.8,88.2L542.2,375.7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M473.9,314.1c0,0-7.9,9.6-24.2-5C449.7,309.1,466,297.9,473.9,314.1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M481.9,322.1c0,0-10-7.4,3.7-24.4C485.6,297.7,497.6,313.3,481.9,322.1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M464.3,295.3c0,0-11.9-3.6-4.7-24.2C459.6,271,476.2,281.7,464.3,295.3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M497.5,338.6c0,0-4.2,11.7-24.5,3.4C473,342,484.5,326,497.5,338.6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M506.8,345.4c0,0-11.1-5.5-0.6-24.7C506.2,320.8,520.8,334.1,506.8,345.4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M518.7,356.1c0,0-4,11.8-24.4,3.9C494.3,360,505.6,343.8,518.7,356.1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M743.5,248.5v347.1c0,10.9-8.8,19.7-19.7,19.7H551c-5.5,0-10.4-2.2-14-5.8c-3.5-3.6-5.7-8.5-5.7-13.9V248.5 c0-10.9,8.8-19.7,19.7-19.7h172.9c3.2,0,6.3,0.8,8.9,2.1C739.2,234.2,743.5,240.8,743.5,248.5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M736.2,248.5v347.1c0,10.9-8.8,19.7-19.7,19.7H543.6c-5.5,0-10.4-2.2-14-5.8c-3.5-3.6-5.7-8.5-5.7-13.9V248.5 c0-10.9,8.8-19.7,19.7-19.7h172.9c3.2,0,6.3,0.8,8.9,2.1C731.8,234.2,736.2,240.8,736.2,248.5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M739.9,314.1h5.7c0.9,0,1.7-0.8,1.7-1.7v-28c0-0.9-0.8-1.7-1.7-1.7h-5.7V314.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M523.9,314.1h-4.4c-0.7,0-1.3-0.6-1.3-1.3v-28.7c0-0.7,0.6-1.3,1.3-1.3h4.4V314.1z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M523.9,355.3h-4.4c-0.7,0-1.3-0.6-1.3-1.3v-28.7c0-0.7,0.6-1.3,1.3-1.3h4.4V355.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M726.4,247.3v349.5c0,4.8-3.9,8.7-8.7,8.7H542.4c-3.6,0-6.7-2.2-8-5.3c-0.4-1-0.7-2.2-0.7-3.4V247.3 c0-4.8,3.9-8.7,8.7-8.7h175.3c0.6,0,1.1,0.1,1.7,0.2c0.6,0.1,1.2,0.3,1.7,0.5c2.7,1.2,4.7,3.6,5.2,6.6 C726.3,246.3,726.4,246.8,726.4,247.3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 534.3,
    y: 346.4,
    className: "st10",
    width: 87.7,
    height: 155.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M649.3,334.3v161.2c0,7.4-4.9,13.8-11.6,16c-1.7,0.6-3.5,0.9-5.3,0.9c-9.3,0-16.9-7.6-16.9-16.9V334.3 c0-9.3,7.6-16.9,16.9-16.9c1.9,0,3.7,0.3,5.3,0.9c2.5,0.8,4.8,2.3,6.6,4.1C647.4,325.4,649.3,329.7,649.3,334.3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M649.3,334.3v161.2c0,7.4-4.9,13.8-11.6,16c-6.7-2.2-11.6-8.6-11.6-16V334.3c0-7.4,4.9-13.8,11.6-16 c2.5,0.8,4.8,2.3,6.6,4.1C647.4,325.4,649.3,329.7,649.3,334.3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M726.4,247.3v35.9H533.7v-35.9c0-4.8,3.9-8.7,8.7-8.7h175.3c0.6,0,1.1,0.1,1.7,0.2c0.6,0.1,1.2,0.3,1.7,0.5 c2.7,1.2,4.7,3.6,5.2,6.6C726.3,246.3,726.4,246.8,726.4,247.3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M642.2,348.3v133.4c0,6-4.9,10.9-10.9,10.9H404.8c-2.7,0-5.2-1-7.1-2.6c-2.3-2-3.8-4.9-3.8-8.2V348.3 c0-6,4.9-10.9,10.9-10.9h226.6C637.4,337.5,642.2,342.3,642.2,348.3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 393.9,
    y: 364.9,
    className: "st7",
    width: 248.3,
    height: 29.6
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M622.4,472.6h-54.7c-1,0-1.9-0.8-1.9-1.9V454c0-1,0.8-1.9,1.9-1.9h54.7c1,0,1.9,0.8,1.9,1.9v16.7 C624.3,471.7,623.5,472.6,622.4,472.6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M426,429.6h-16.4c-0.7,0-1.3-0.6-1.3-1.3v-8.6c0-0.7,0.6-1.3,1.3-1.3H426c0.7,0,1.3,0.6,1.3,1.3v8.6 C427.3,429,426.7,429.6,426,429.6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M459.4,429.6H443c-0.7,0-1.3-0.6-1.3-1.3v-8.6c0-0.7,0.6-1.3,1.3-1.3h16.4c0.7,0,1.3,0.6,1.3,1.3v8.6 C460.7,429,460.1,429.6,459.4,429.6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M492.8,429.6h-16.4c-0.7,0-1.3-0.6-1.3-1.3v-8.6c0-0.7,0.6-1.3,1.3-1.3h16.4c0.7,0,1.3,0.6,1.3,1.3v8.6 C494.1,429,493.6,429.6,492.8,429.6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M526.3,429.6h-16.4c-0.7,0-1.3-0.6-1.3-1.3v-8.6c0-0.7,0.6-1.3,1.3-1.3h16.4c0.7,0,1.3,0.6,1.3,1.3v8.6 C527.6,429,527,429.6,526.3,429.6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M559.7,429.6h-16.4c-0.7,0-1.3-0.6-1.3-1.3v-8.6c0-0.7,0.6-1.3,1.3-1.3h16.4c0.7,0,1.3,0.6,1.3,1.3v8.6 C561,429,560.4,429.6,559.7,429.6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M593.1,429.6h-16.4c-0.7,0-1.3-0.6-1.3-1.3v-8.6c0-0.7,0.6-1.3,1.3-1.3h16.4c0.7,0,1.3,0.6,1.3,1.3v8.6 C594.4,429,593.8,429.6,593.1,429.6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M626.5,429.6h-16.4c-0.7,0-1.3-0.6-1.3-1.3v-8.6c0-0.7,0.6-1.3,1.3-1.3h16.4c0.7,0,1.3,0.6,1.3,1.3v8.6 C627.8,429,627.2,429.6,626.5,429.6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 393.9,
    y: 349.2,
    className: "st11",
    width: 248.3,
    height: 5.7
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M438.7,475.5h-27.3c-1.7,0-3.1-1.4-3.1-3.1v-27.3c0-1.7,1.4-3.1,3.1-3.1h27.3c1.7,0,3.1,1.4,3.1,3.1v27.3 C441.7,474.1,440.4,475.5,438.7,475.5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M556.9,467H450.8c-0.6,0-1.1-0.5-1.1-1.1v-7.1c0-0.6,0.5-1.1,1.1-1.1h106.1c0.6,0,1.1,0.5,1.1,1.1v7.1 C557.9,466.5,557.4,467,556.9,467"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 393.9,
    y: 337.5,
    width: 156.3,
    height: 152.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M550.2,337.5L397.7,490c-2.3-2-3.8-4.9-3.8-8.2V435l97.5-97.5H550.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 447,
    y: 337.5,
    width: 183.9,
    height: 155.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "630.9,337.5 475.8,492.6 447,492.6 602.1,337.5  "
  })))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M827.3,618.5h-22c-3,0-5.6-3.4-6.6-8.4l-9.3-50.6c-0.4-2.1,0.4-4.2,1.7-4.4c17-2.3,33.8-2.3,50.5,0 c1.2,0.2,2,2.3,1.7,4.4l-9.3,50.6C833,615.1,830.3,618.5,827.3,618.5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M840.6,557.7c0,1.5-10.8,2.7-24.2,2.7c-13.3,0-24.2-1.2-24.2-2.7c0-1.5,10.8-2.7,24.2-2.7 C829.8,555,840.6,556.2,840.6,557.7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M858.2,490.5c-13.2-3.5-33.4,24-39.6,50.7v-39c3.1-5.5,9-13.7,19.6-22.4c16.6-13.5,31.9-30.9,18.6-34.4 c-12.4-3.3-31,20.7-38.3,45.8v-50.1c2.1-3.3,5.6-7.7,11.2-12.2c10.5-8.5,20.1-19.5,11.8-21.7c-7.2-1.9-17.8,10.9-23,25.4v-16.2 c0.9-5,2.1-12.2,5.4-19.5c7.7-17,11.9-34.5,1.7-33.2c-10.2,1.3-16.7,31.6-11.2,54.8v8.4c-3.8-17-16.6-34.6-25-32.4 c-8.4,2.2,1.3,13.1,11.8,21.7c8,6.5,11.7,12.6,13.3,15.8v39.5c-6-26.9-26.4-54.7-39.7-51.2c-13.2,3.5,2,20.8,18.6,34.4 c12.6,10.2,18.5,19.8,21,25V527c-6.4-26.4-26.3-53.1-39.3-49.6c-13.2,3.5-1.9,16.2,16.8,31.5c12.7,10.4,19.5,21.4,22.5,27.4v22.3 c1.5,0.4,2.9,0.4,4.1,0v-8.9c2.6-5.3,8.5-14.7,20.9-24.8C856.1,511.3,871.4,494,858.2,490.5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M622.5,613.1c0,0,0,0.1,0,0.1c0,1.7-0.9,3.3-2.5,4.8c-0.4,0.4-0.8,0.7-1.3,1.1c-1.4,1-3.1,1.9-5,2.8 c-0.4,0.2-0.9,0.4-1.3,0.5c-1.5,0.6-3.2,1.2-5,1.7c-0.4,0.1-0.9,0.2-1.3,0.4c-1.6,0.4-3.3,0.8-5,1.2c-0.4,0.1-0.9,0.2-1.3,0.3 c-1.6,0.3-3.3,0.6-5,0.8c-0.4,0.1-0.9,0.1-1.3,0.2c-1.6,0.2-3.3,0.4-5,0.6c-0.4,0-0.9,0.1-1.3,0.1c-1.6,0.1-3.3,0.2-5,0.3 c-0.4,0-0.9,0-1.3,0.1c-1.7,0.1-3.3,0.1-5,0.1c-0.3,0-0.6,0-0.9,0c-0.1,0-0.3,0-0.4,0c-1.7,0-3.4,0-5-0.1c-0.4,0-0.9,0-1.3-0.1 c-1.3-0.1-2.5-0.1-3.7-0.2c-0.4,0-0.9-0.1-1.3-0.1c-0.4,0-0.9-0.1-1.3-0.1c-1.7-0.2-3.4-0.3-5-0.5c-0.4-0.1-0.9-0.1-1.3-0.2 c-1-0.1-2.1-0.3-3.1-0.5c-0.7-0.1-1.3-0.2-2-0.3c-0.4-0.1-0.9-0.2-1.3-0.3c-1.8-0.3-3.4-0.7-5-1.1c-0.3-0.1-0.6-0.2-0.9-0.2 c-0.1,0-0.3-0.1-0.4-0.1c-0.7-0.2-1.4-0.4-2.1-0.6c-1-0.3-2-0.7-2.9-1c-0.5-0.2-0.9-0.4-1.3-0.5c-1.7-0.7-3.2-1.5-4.5-2.3 c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2-0.2-0.5-0.3-0.7-0.5c-1.9-1.6-3-3.3-3-5.1c0-0.1,0-0.3,0-0.4l0-10.2 l2.9,0l1.3,0l5,0l1.3,0l3.9,0l1.1,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0 l1.3,0l5,0l1.3,0h0.3l4.7,0l1.3,0l5,0l1.3,0l2.5,0L622.5,613.1L622.5,613.1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.8,602.6v16.8c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2-0.2-0.5-0.3-0.7-0.5v-15.8L530.8,602.6z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.2,602.6v20c-0.5-0.2-0.9-0.4-1.3-0.5v-19.4L537.2,602.6z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M543.5,602.6v22c-0.3-0.1-0.6-0.2-0.9-0.2c-0.1,0-0.3-0.1-0.4-0.1v-21.6L543.5,602.6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M549.9,602.5v23.4c-0.4-0.1-0.9-0.2-1.3-0.3v-23.1L549.9,602.5z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M556.3,602.5v24.4c-0.4-0.1-0.9-0.1-1.3-0.2v-24.2L556.3,602.5z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.6,602.5v25c-0.4,0-0.9-0.1-1.3-0.1v-24.9L562.6,602.5z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569,602.5v25.4c-0.4,0-0.9,0-1.3-0.1v-25.4L569,602.5z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M575.4,602.5V628c-0.3,0-0.6,0-0.9,0c-0.1,0-0.3,0-0.4,0v-25.5L575.4,602.5z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M581.7,602.5v25.4c-0.4,0-0.9,0-1.3,0.1v-25.4L581.7,602.5z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.1,602.5v24.9c-0.4,0-0.9,0.1-1.3,0.1v-25L588.1,602.5z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M594.5,602.5v24.2c-0.4,0.1-0.9,0.1-1.3,0.2v-24.4L594.5,602.5z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M600.8,602.5v23.1c-0.4,0.1-0.9,0.2-1.3,0.3v-23.4L600.8,602.5z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M607.2,602.5V624c-0.4,0.1-0.9,0.2-1.3,0.4v-21.9L607.2,602.5z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.6,602.5v19.3c-0.4,0.2-0.9,0.4-1.3,0.5v-19.9L613.6,602.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.9,602.4V618c-0.4,0.4-0.8,0.7-1.3,1.1v-16.6L619.9,602.4z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M622.4,602.6c0,7.5-21.5,13.6-48,13.6c-3.6,0-7.1-0.1-10.5-0.3c-4.3-0.3-8.3-0.7-12.1-1.3 c-3.3-0.5-6.5-1.1-9.3-1.8c-0.9-0.2-1.7-0.4-2.5-0.7c-3.5-1-6.5-2.2-8.7-3.5c-0.4-0.3-0.9-0.5-1.2-0.8c-2.3-1.6-3.6-3.4-3.6-5.2 c0-0.2,0-0.3,0-0.5c0.9-7.3,22-13.1,47.9-13.1c6.4,0,12.5,0.4,18,1c1.1,0.1,2.1,0.3,3.2,0.4c4.5,0.6,8.6,1.5,12.2,2.4 c0.8,0.2,1.5,0.4,2.3,0.7c2.6,0.8,4.9,1.7,6.7,2.7c1.9,1,3.4,2.1,4.3,3.3c0.7,0.8,1.1,1.7,1.2,2.6 C622.4,602.2,622.4,602.4,622.4,602.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 551.9,
    y: 596.2,
    width: 69.3,
    height: 19.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M621.2,599.5l-57.2,16.4c-4.3-0.3-8.3-0.7-12.1-1.3l65-18.4C618.8,597.2,620.2,598.3,621.2,599.5"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 530.2,
    y: 589.9,
    width: 65.5,
    height: 18.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M595.7,590.3l-64.3,18.2c-0.4-0.3-0.9-0.5-1.2-0.8l62.3-17.8C593.6,590.1,594.6,590.2,595.7,590.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 540.1,
    y: 592.8,
    width: 70,
    height: 20
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M610.2,593.5l-67.5,19.3c-0.9-0.2-1.7-0.4-2.5-0.7l67.7-19.3C608.7,593,609.4,593.2,610.2,593.5"
  })))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M612.8,602.6c0,0.2,0,0.3,0,0.5c-0.9,5.8-17.7,10.4-38.3,10.4c-20.5,0-37.4-4.6-38.3-10.4c0-0.2,0-0.3,0-0.5 c0-6,17.2-10.9,38.3-10.9C595.6,591.7,612.8,596.6,612.8,602.6"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M612.8,603.1c-0.9,5.8-17.7,10.4-38.3,10.4c-0.5,0-0.9,0-1.4,0c-4.6,0-9-0.3-13-0.8c-4-0.5-7.7-1.1-11-1.9 c-0.8-0.2-1.6-0.4-2.4-0.6c-3.4-1-6.2-2.2-8-3.6c-0.4-0.3-0.8-0.6-1.2-1c-0.8-0.8-1.3-1.6-1.4-2.5c0.9-5.8,17.7-10.4,38.3-10.4 c2.6,0,5.1,0.1,7.6,0.2c1.3,0.1,2.5,0.2,3.7,0.3c4.9,0.4,9.5,1.1,13.3,2.1c0.8,0.2,1.6,0.4,2.4,0.6c3,0.9,5.5,1.8,7.4,2.9 c1.8,1.1,3.1,2.2,3.6,3.5C612.7,602.5,612.7,602.8,612.8,603.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 560.1,
    y: 598.8,
    width: 52.4,
    height: 14.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M612.5,602.3l-39.4,11.2c-4.6,0-9-0.3-13-0.8l48.8-13.9C610.8,599.9,612,601,612.5,602.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 537.6,
    y: 592.9,
    width: 48.2,
    height: 13.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M585.8,593.2l-47,13.4c-0.4-0.3-0.8-0.7-1.2-1l44.5-12.6C583.3,593,584.6,593.1,585.8,593.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 546.8,
    y: 595.2,
    width: 54.7,
    height: 15.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M601.5,595.9l-52.4,14.9c-0.8-0.2-1.6-0.4-2.4-0.6l52.3-14.9C599.9,595.4,600.7,595.6,601.5,595.9"
  })))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M579.8,608.7v1.8h-8.1v-1.7c-5.7-0.1-11.3-0.5-14.7-1.1l4.4-2.8c3.8,0.6,8.8,1,13.3,1c3.8,0,5.2-0.2,5.2-0.6 c0-1.4-22.2-0.3-22.2-4.5c0-1.8,4.7-3.4,14.1-3.8v-1.8h8.1v1.7c4.2,0.1,8.4,0.4,11.6,0.9l-4.1,2.8c-4-0.6-7.7-0.8-11.2-0.8 c-4,0-5.2,0.3-5.2,0.7c0,1.4,22.2,0.2,22.2,4.4C593.2,606.8,588.7,608.3,579.8,608.7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M579.6,608.1v1.8h-8.1v-1.7c-5.7-0.1-11.3-0.5-14.7-1.1l4.4-2.8c3.8,0.6,8.8,1,13.3,1c3.8,0,5.2-0.2,5.2-0.6 c0-1.4-22.2-0.3-22.2-4.5c0-1.8,4.7-3.4,14.1-3.8v-1.8h8.1v1.7c4.2,0.1,8.4,0.4,11.6,0.9l-4.1,2.8c-4-0.6-7.7-0.8-11.2-0.8 c-4,0-5.2,0.3-5.2,0.7c0,1.4,22.2,0.2,22.2,4.4C592.9,606.2,588.5,607.7,579.6,608.1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M625.5,596.3c0,0,0,0.1,0,0.1c0,1.7-0.9,3.3-2.5,4.8c-0.4,0.4-0.8,0.7-1.3,1.1c-1.4,1-3.1,1.9-5,2.8 c-0.4,0.2-0.9,0.4-1.3,0.5c-1.5,0.6-3.2,1.2-5,1.7c-0.4,0.1-0.9,0.2-1.3,0.4c-1.6,0.4-3.3,0.8-5,1.2c-0.4,0.1-0.9,0.2-1.3,0.3 c-1.6,0.3-3.3,0.6-5,0.8c-0.4,0.1-0.9,0.1-1.3,0.2c-1.6,0.2-3.3,0.4-5,0.6c-0.4,0-0.9,0.1-1.3,0.1c-1.6,0.1-3.3,0.2-5,0.3 c-0.4,0-0.9,0-1.3,0.1c-1.7,0.1-3.3,0.1-5,0.1c-0.3,0-0.6,0-0.9,0c-0.1,0-0.3,0-0.4,0c-1.7,0-3.4,0-5-0.1c-0.4,0-0.9,0-1.3-0.1 c-1.3-0.1-2.5-0.1-3.7-0.2c-0.4,0-0.9-0.1-1.3-0.1c-0.4,0-0.9-0.1-1.3-0.1c-1.7-0.2-3.4-0.3-5-0.5c-0.4-0.1-0.9-0.1-1.3-0.2 c-1-0.1-2.1-0.3-3.1-0.5c-0.7-0.1-1.3-0.2-2-0.3c-0.4-0.1-0.9-0.2-1.3-0.3c-1.8-0.3-3.4-0.7-5-1.1c-0.3-0.1-0.6-0.2-0.9-0.2 c-0.1,0-0.3-0.1-0.4-0.1c-0.7-0.2-1.4-0.4-2.1-0.6c-1-0.3-2-0.7-2.9-1c-0.5-0.2-0.9-0.4-1.3-0.5c-1.7-0.7-3.2-1.5-4.5-2.3 c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2-0.2-0.5-0.3-0.7-0.5c-1.9-1.6-3-3.3-3-5.1c0-0.1,0-0.3,0-0.4l0-10.2 l2.9,0l1.3,0l5,0l1.3,0l3.9,0l1.1,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0l1.3,0l5,0 l1.3,0l5,0l1.3,0h0.3l4.7,0l1.3,0l5,0l1.3,0l2.5,0L625.5,596.3L625.5,596.3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.8,585.8v16.8c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2-0.2-0.5-0.3-0.7-0.5v-15.8L533.8,585.8z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.2,585.8v20c-0.5-0.2-0.9-0.4-1.3-0.5v-19.4L540.2,585.8z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M546.6,585.8v22c-0.3-0.1-0.6-0.2-0.9-0.2c-0.1,0-0.3-0.1-0.4-0.1v-21.6L546.6,585.8z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M552.9,585.7v23.4c-0.4-0.1-0.9-0.2-1.3-0.3v-23.1L552.9,585.7z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M559.3,585.7v24.4c-0.4-0.1-0.9-0.1-1.3-0.2v-24.2L559.3,585.7z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M565.7,585.7v25c-0.4,0-0.9-0.1-1.3-0.1v-24.9L565.7,585.7z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M572,585.7v25.4c-0.4,0-0.9,0-1.3-0.1v-25.4L572,585.7z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M578.4,585.7v25.5c-0.3,0-0.6,0-0.9,0c-0.1,0-0.3,0-0.4,0v-25.5L578.4,585.7z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584.8,585.7v25.4c-0.4,0-0.9,0-1.3,0.1v-25.4L584.8,585.7z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.1,585.7v24.9c-0.4,0-0.9,0.1-1.3,0.1v-25L591.1,585.7z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M597.5,585.7v24.2c-0.4,0.1-0.9,0.1-1.3,0.2v-24.4L597.5,585.7z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.8,585.7v23.1c-0.4,0.1-0.9,0.2-1.3,0.3v-23.4L603.8,585.7z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M610.2,585.7v21.6c-0.4,0.1-0.9,0.2-1.3,0.4v-21.9L610.2,585.7z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.6,585.7V605c-0.4,0.2-0.9,0.4-1.3,0.5v-19.9L616.6,585.7z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M622.9,585.6v15.5c-0.4,0.4-0.8,0.7-1.3,1.1v-16.6L622.9,585.6z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M625.5,585.8c0,7.5-21.5,13.6-48,13.6c-3.6,0-7.1-0.1-10.5-0.3c-4.3-0.3-8.3-0.7-12.1-1.3 c-3.3-0.5-6.5-1.1-9.3-1.8c-0.9-0.2-1.7-0.4-2.5-0.7c-3.5-1-6.5-2.2-8.7-3.5c-0.4-0.3-0.9-0.5-1.2-0.8c-2.3-1.6-3.6-3.4-3.6-5.2 c0-0.2,0-0.3,0-0.5c0.9-7.3,22-13.1,47.9-13.1c6.4,0,12.5,0.4,18,1c1.1,0.1,2.1,0.3,3.2,0.4c4.5,0.6,8.6,1.5,12.2,2.4 c0.8,0.2,1.6,0.4,2.3,0.7c2.6,0.8,4.9,1.7,6.7,2.7c1.9,1,3.4,2.1,4.3,3.3c0.7,0.8,1.1,1.7,1.2,2.6 C625.4,585.4,625.5,585.6,625.5,585.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 554.9,
    y: 579.4,
    width: 69.3,
    height: 19.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M624.2,582.7L567,599.1c-4.3-0.3-8.3-0.7-12.1-1.3l65-18.4C621.8,580.4,623.3,581.5,624.2,582.7"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 533.2,
    y: 573.1,
    width: 65.5,
    height: 18.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M598.7,573.5l-64.3,18.2c-0.4-0.3-0.9-0.5-1.2-0.8l62.3-17.8C596.6,573.3,597.6,573.4,598.7,573.5"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 543.1,
    y: 576,
    width: 70,
    height: 19.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M613.2,576.7l-67.5,19.3c-0.9-0.2-1.7-0.4-2.5-0.7l67.7-19.3C611.7,576.2,612.4,576.4,613.2,576.7"
  })))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M615.8,585.8c0,0.2,0,0.3,0,0.5c-0.9,5.8-17.7,10.4-38.3,10.4s-37.4-4.6-38.3-10.4c0-0.2,0-0.3,0-0.5 c0-6,17.2-10.9,38.3-10.9S615.8,579.8,615.8,585.8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M615.8,586.3c-0.9,5.8-17.7,10.4-38.3,10.4c-0.5,0-0.9,0-1.4,0c-4.6,0-9-0.3-13-0.8c-4-0.5-7.7-1.1-11-1.9 c-0.8-0.2-1.6-0.4-2.4-0.6c-3.4-1-6.2-2.2-8-3.6c-0.4-0.3-0.8-0.6-1.2-1c-0.8-0.8-1.3-1.6-1.4-2.5c0.9-5.8,17.7-10.4,38.3-10.4 c2.6,0,5.1,0.1,7.6,0.2c1.3,0.1,2.5,0.2,3.7,0.3c4.9,0.4,9.5,1.1,13.3,2.1c0.8,0.2,1.6,0.4,2.4,0.6c3,0.9,5.5,1.8,7.4,2.9 c1.8,1.1,3.1,2.2,3.6,3.5C615.7,585.7,615.8,586,615.8,586.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 563.1,
    y: 582,
    width: 52.4,
    height: 14.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M615.6,585.4l-39.4,11.2c-4.6,0-9-0.3-13-0.8l48.8-13.9C613.8,583.1,615,584.2,615.6,585.4"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 540.6,
    y: 576.1,
    width: 48.2,
    height: 13.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M588.8,576.4l-47,13.4c-0.4-0.3-0.8-0.6-1.2-1l44.5-12.6C586.4,576.2,587.6,576.3,588.8,576.4"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 549.8,
    y: 578.4,
    width: 54.7,
    height: 15.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M604.5,579.1l-52.4,14.9c-0.8-0.2-1.6-0.4-2.4-0.6l52.3-14.9C602.9,578.6,603.8,578.8,604.5,579.1"
  })))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M582.8,591.9v1.8h-8.1V592c-5.7-0.1-11.3-0.5-14.7-1.1l4.4-2.8c3.8,0.6,8.8,1,13.3,1c3.8,0,5.2-0.2,5.2-0.6 c0-1.4-22.2-0.3-22.2-4.5c0-1.8,4.7-3.4,14.1-3.8v-1.8h8.1v1.7c4.2,0.1,8.4,0.4,11.6,0.9l-4.1,2.8c-4-0.6-7.7-0.8-11.2-0.8 c-4,0-5.2,0.3-5.2,0.7c0,1.4,22.2,0.2,22.2,4.4C596.2,590,591.7,591.5,582.8,591.9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M582.6,591.3v1.8h-8.1v-1.7c-5.7-0.1-11.3-0.5-14.7-1.1l4.4-2.8c3.8,0.6,8.8,1,13.3,1c3.8,0,5.2-0.2,5.2-0.6 c0-1.4-22.2-0.3-22.2-4.5c0-1.8,4.7-3.4,14.1-3.8v-1.8h8.1v1.7c4.2,0.1,8.4,0.4,11.6,0.9l-4.1,2.8c-4-0.6-7.7-0.8-11.2-0.8 c-4,0-5.2,0.3-5.2,0.7c0,1.4,22.2,0.2,22.2,4.4C596,589.4,591.5,590.9,582.6,591.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.970b8d2bab4ed9c265cf01513d9d5891.svg";
export { ForwardRef as ReactComponent };